var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPreview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_160617",
    "data-name": "Group 160617",
    transform: "translate(-1828 -297)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_147728",
    "data-name": "Rectangle 147728",
    transform: "translate(1828 297)",
    fill: "#f5f7f8",
    stroke: "rgba(112,112,112,0.15)",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    rx: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 37,
    height: 37,
    rx: 9.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Polygon_1",
    "data-name": "Polygon 1",
    transform: "translate(1857 307) rotate(90)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.78,2.9a2,2,0,0,1,3.439,0l5.987,10.083A2,2,0,0,1,15.487,16H3.513a2,2,0,0,1-1.72-3.021Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 9.500000953674316 2.917431831359863 C 9.328850746154785 2.917431831359863 8.902441024780273 2.965122222900391 8.640140533447266 3.406891822814941 L 2.653621673583984 13.48946189880371 C 2.385700225830078 13.94069194793701 2.557931900024414 14.34277153015137 2.644411087036133 14.49470138549805 C 2.730901718139648 14.64663124084473 2.988700866699219 15.00000190734863 3.513470649719238 15.00000190734863 L 15.48652076721191 15.00000190734863 C 16.01130104064941 15.00000190734863 16.26910018920898 14.64663124084473 16.35558128356934 14.49470138549805 C 16.44207000732422 14.34277153015137 16.61429023742676 13.94069194793701 16.34638023376465 13.48946189880371 L 10.35985088348389 3.406891822814941 C 10.09756088256836 2.965122222900391 9.671151161193848 2.917431831359863 9.500000953674316 2.917431831359863 M 9.500000953674316 1.917428970336914 C 10.16611099243164 1.917428970336914 10.83222103118896 2.24373722076416 11.21971130371094 2.89635181427002 L 17.20623016357422 12.97892189025879 C 17.99781036376953 14.31210136413574 17.03700065612793 16.00000190734863 15.48652076721191 16.00000190734863 L 3.513470649719238 16.00000190734863 C 1.963001251220703 16.00000190734863 1.002191543579102 14.31210136413574 1.793760299682617 12.97892189025879 L 7.780290603637695 2.89635181427002 C 8.167780876159668 2.24373722076416 8.833890914916992 1.917428970336914 9.500000953674316 1.917428970336914 Z",
    stroke: "none",
    fill: "#000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreview);
export default __webpack_public_path__ + "static/media/preview.44b60fdc37fa9ff23f51f4d6bd6e9489.svg";
export { ForwardRef as ReactComponent };